import React from "react";

const PAY = {
  unpaid: { label: "Sin pago", color: "border-gray-300 text-gray-600" },
  pending_confirmation: { label: "Pago pendiente", color: "border-amber-400 text-amber-700" },
  paid: { label: "Pagado", color: "border-emerald-500 text-emerald-700" },
};

const REV = {
  not_started: { label: "Sin iniciar", color: "border-gray-300 text-gray-600" },
  in_review: { label: "En revisión", color: "border-primary text-primary" },
  approved: { label: "Aprobado", color: "border-emerald-500 text-emerald-700" },
  rejected: { label: "Rechazado", color: "border-red-500 text-red-700" },
};

const STATUS = {
  draft: { label: "Borrador", color: "border-gray-300 text-gray-700" },
};

function Pill({ map, value, testid }) {
  const cfg = map[value] || { label: value || "—", color: "border-gray-300 text-gray-600" };
  return (
    <span
      data-testid={testid}
      className={`inline-block text-[10px] uppercase tracking-widest border px-2 py-[2px] whitespace-nowrap ${cfg.color}`}
    >
      {cfg.label}
    </span>
  );
}

export function PaymentBadge({ value, testid = "payment-badge" }) {
  return <Pill map={PAY} value={value} testid={testid} />;
}
export function ReviewBadge({ value, testid = "review-badge" }) {
  return <Pill map={REV} value={value} testid={testid} />;
}
export function CaseStatusBadge({ value, testid = "status-badge" }) {
  return <Pill map={STATUS} value={value} testid={testid} />;
}
